export default __webpack_public_path__ + "static/media/rkt.acca2e6b.svg";